export const GET_DATA_BY_CATEGORY_REQUEST = "GET_DATA_BY_CATEGORY_REQUEST";
export const GET_DATA_BY_CATEGORY_SUCCESS = "GET_DATA_BY_CATEGORY_SUCCESS";
export const GET_DATA_BY_CATEGORY_FAILURE = "GET_DATA_BY_CATEGORY_FAILURE";


export const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_FAILURE = "ADD_TO_CART_FAILURE";


// export const FINAL_CART_SET_SUCCESS = "FINAL_CART_SET_SUCCESS";

// export const FETCH_IN_CART_REQUEST = "FETCH_IN_CART_REQUEST";
// export const FETCH_IN_CART_SUCCESS = "FETCH_IN_CART_SUCCESS";
// export const FETCH_IN_CART_FAILURE = "FETCH_IN_CART_FAILURE";

export const ADD_TO_WISHLIST_REQUEST ="ADD_TO_WISHLIST_REQUEST";
export const ADD_TO_WISHLIST_SUCCESS ="ADD_TO_WISHLIST_SUCCESS"; 
export const ADD_TO_WISHLIST_FAILURE ="ADD_TO_WISHLIST_FAILURE";

export const FINAL_WISH_SET_SUCCESS = "FINAL_WISH_SET_SUCCESS";

export const FETCH_IN_WISHLIST_REQUEST = "FETCH_IN_WISHLIST_REQUEST";
export const FETCH_IN_WISHLIST_SUCCESS = "FETCH_IN_WISHLIST_SUCCESS";
export const FETCH_IN_WISHLIST_FAILURE = "FETCH_IN_WISHLIST_FAILURE";
